import * as go from 'gojs';

import { DiagramTransaction } from 'src/containers/ProjectDiagram/constants/transactions';
import { ModelConceptClass } from 'src/containers/ProjectDiagram/types/data';
import { Diagram } from 'src/containers/ProjectDiagram/types/diagram';
import { commitDiagramWhileSkippingUndoManager } from 'src/containers/ProjectDiagram/utils/commitDiagramModel';
import { setDataProperty } from 'src/containers/ProjectDiagram/utils/setDataProperty';

export const toggleIsAttributesOpen =
  (isAttributesOpen: boolean): NonNullable<go.Panel['click']> =>
  (event) => {
    const classNode = event.targetObject?.part;
    if (classNode) {
      const data = classNode.data as ModelConceptClass;
      if (data.isAttributesOpen !== isAttributesOpen) {
        commitDiagramWhileSkippingUndoManager(
          event.diagram as Diagram,
          (model) =>
            setDataProperty<ModelConceptClass>(model)(
              data,
              'isAttributesOpen',
              isAttributesOpen
            ),
          DiagramTransaction.TOGGLE_ATTRIBUTES_PANEL
        );
      }
    }
  };
